export default function getResizeUrl(width: number, height: number, url: string) {
  return `https://image.heydealer.com/unsafe/${width}x${height}/${url}`;
}
